import BaseCard from "../../../components/common/cards/BaseCard";

export default BaseCard;
